import ToolTipTitle from './ToolTipTitle';

export default ToolTipTitle;
export type { IToolTipTitleProps } from './ToolTipTitle';
